import { createTheme } from "@mui/material";

export const theme = () =>
  createTheme({
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 960,
        lg: 1280,
        xl: 1536,
        // xxl: 2600,
      },
    },
    palette: {
      primary: {
        main: "#1570EF",
      },
    },
    components: {
      MuiCard: {
        styleOverrides: {
          root: {
            borderRadius: "12px;",
            boxShadow:
              "0px 4px 8px -2px rgba(16, 24, 40, 0.1), 0px 2px 4px -2px rgba(16, 24, 40, 0.06)",
          },
        },
      },
      MuiTextField: {
        styleOverrides: {
          root: {
            [`& fieldset`]: {
              borderRadius: "8px",
            },
          },
        },
      },
      MuiInputLabel: {
        styleOverrides: {
          root: {
            fontSize: "14px",
            lineHeight: "20px",
            fontWeight: "400",
            color: "#344054",
          },
        },
      },
      MuiTypography: {
        styleOverrides: {
          root: {
            fontSize: "14px",
            lineHeight: "20px",
            fontWeight: "400",
          },
        },
        variants: [
          {
            props: { color: "secondary" },
            style: {
              color: "#475467",
            },
          },
        ],
      },
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: "8px",
            fontWeight: "600",
            textTransform: "none",
            fontSize: "16px",
            lineHeight: "24px",
            padding: "10px 16px",
          },
        },
      },
      MuiLink: {
        styleOverrides: {
          root: {
            textDecoration: "none",
          },
        },
      },
      MuiContainer: {
        styleOverrides: {
          root: {
            paddingRight: "32px",
            paddingLeft: "32px",
            // maxWidth: "1280px",
          },

          // maxWidthLg: {
          //   maxWidth: "1280px",
          // },
        },
      },
      MuiChip: {
        styleOverrides: {
          root: {
            fontSize: "14px",
            fontWeight: "500",
            lineHeight: "20px",
          },
        },
        variants: [
          {
            props: { variant: "outlined" },
            style: {
              border: "1.5px solid #475467",
              ".MuiChip-label": {
                padding: "0px 8px",
              },
            },
          },
        ],
      },
    },
  });
